import { TypedAnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { SelectFacetTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/selectFacet.trackingInfo";

import * as AlgoliaUserService from "@/services/algolia/algoliaUser.service";

import {
    AlgoliaAnalyticsEventNames,
    AlgoliaAnalyticsEvents
} from "../AlgoliaAnalyticsEvents";
import {
    AlgoliaAnalyticsMinimumDataset,
    AlgoliaFilterClickedPayload
} from "../AlgoliaAnalyticsMinimumDataset";

export interface AlgoliaAnalyticsSearchFilterImpression
    extends AlgoliaAnalyticsMinimumDataset<AlgoliaFilterClickedPayload> {}

const getAlgoliaProductFilterAppliedPayload = (
    eventData: SelectFacetTrackingInfo
): AlgoliaFilterClickedPayload => {
    const filter = decodeURIComponent(eventData.filter).split(":");

    return {
        authenticatedUserToken: AlgoliaUserService.getAuthenticatedUserToken(),
        eventName: AlgoliaAnalyticsEventNames.FilterApplied,
        index: eventData.index,
        userToken: AlgoliaUserService.getUserToken(),
        filters: [
            filter.length !== 2
                ? eventData.filter
                : `${encodeURIComponent(filter[0])}:${encodeURIComponent(
                      filter[1]
                  )}`
        ]
    };
};

const getAlgoliaAnalyticsSearchFilterImpression = (
    data: TypedAnalyticsEvent<SelectFacetTrackingInfo>
): Array<AlgoliaAnalyticsSearchFilterImpression> => {
    const payload = getAlgoliaProductFilterAppliedPayload(
        data.payload.eventData
    );

    return [
        {
            eventName: AlgoliaAnalyticsEvents.ClickedFilters,
            payload: payload
        }
    ];
};

export { getAlgoliaAnalyticsSearchFilterImpression };
